const NaverLogo = 'https://webtoon.today/naver.png';
const DaumLogo = 'https://webtoon.today/daum.png';
const KakaoLogo = 'https://webtoon.today/kakao.png';
const ToomicsLogo = 'https://webtoon.today/toomics.png';
const ToptoonLogo = 'https://webtoon.today/toptoon.png';
const LezhinLogo = 'https://webtoon.today/lezhin.png';
const ComicoLogo = 'https://webtoon.today/comico.png';

export {NaverLogo, DaumLogo, KakaoLogo, ToomicsLogo, ToptoonLogo, LezhinLogo, ComicoLogo};
